/* eslint-disable camelcase, max-statements, react/prop-types, max-lines */
import React, {useState, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Segment, Table, Input, Button, Message, Icon, Modal, Dropdown} from 'semantic-ui-react';
import {Actions} from './../../../../../common/actions';
import moment from 'moment';

const {
  getWtsMatriculas,
  updateWtsMatricula,
  getWtsEmployeesByCerts,
  createWtsCertificacion,
  updateWtsAgenda,
  getWtsDealer,
} = Actions;

const SortIcon = ({direction}) => {
  if (!direction) {
    return (
      <span style={{'marginLeft': '5px', 'opacity': '0.4', 'fontSize': '1.2em'}}>⇅</span>
    );
  }
  return (
    <span style={{'marginLeft': '5px', 'fontSize': '1.2em'}}>
      {(direction === 'asc') ? '↑' : '↓'}
    </span>
  );
};

const WtsCalificacionMatriculados = ({courseToEdit, reduxData, onClose}) => {
  const dispatch = useDispatch();
  const [grades, setGrades] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [filters, setFilters] = useState({
    'id': 'ALL',
    'doc': 'ALL',
    'fullName': 'ALL',
    'dealer': 'ALL',
    'agency': 'ALL',
    'grade': 'ALL',
    'approvalStatus': 'ALL',
  });
  const [sortConfig, setSortConfig] = useState({'key': null, 'direction': null});
  const [userDealerSet, setUserDealerSet] = useState(false);

  const reduxState = useSelector((state) => ({
    'enrolled': state.wtsMatriculas?.matriculas || [],
    'loading': state.wtsMatriculas?.loading || state.wtsEmployees?.loading || false,
    'certEmployees': state.wtsEmployees?.employeesByCerts || [],
    'allEmployees': state.wtsEmployees?.employeesGestor || [],
    'rucEmployees': state.wtsEmployees?.employeesByRuc || [],
    'dealers': state.wtsDealer?.dealers || [],
    'currentUser': state.session?.session?.user || state.session?.user || state.session || null,
  }));

  const {enrolled, loading, certEmployees, allEmployees, rucEmployees, dealers, currentUser} = reduxState;

  const courseStatus = courseToEdit?.status || courseToEdit?.estado;
  const validStatuses = ['E', 'C', 'X'];
  const isCourseFinished = validStatuses.includes(courseStatus);
  const writenTestValue = Number(courseToEdit?.writen_test_value || 0);
  const practicesValue = Number(courseToEdit?.practices_value || 0);

  useEffect(() => {
    if ((typeof getWtsDealer === 'function') && (dealers.length === 0)) {
      dispatch(getWtsDealer());
    }
  }, [dispatch, dealers.length]);

  useEffect(() => {
    if (courseToEdit?.id) {
      dispatch(getWtsMatriculas(courseToEdit.id));
    }
  }, [courseToEdit?.id, dispatch]);

  useEffect(() => {
    if (courseToEdit && reduxData && isCourseFinished) {
      const areaId = reduxData.areaSelected?.id || reduxData.areaSelected?.value || 1;
      const directedRaw = courseToEdit.directed_to ||
        courseToEdit.destinatarios || courseToEdit.course_destinatarios || [];

      const directedIds = directedRaw.map((d) => {
        if ((typeof d === 'object') && (d !== null)) {
          return String(d.id || d.idCursoDestino || d.course_id_destino || d.course_id);
        }
        return String(d);
      });

      const certs = (reduxData.courses || [])
        .filter((c) => directedIds.includes(String(c.id)))
        .map((c) => String(c.course || c.description || ''))
        .filter((name) => name !== '');

      dispatch(getWtsEmployeesByCerts({
        'area': Number(areaId),
        'certificates': certs,
        'profile_id': 1,
        'ruc_filter': '',
      }));
    }
  }, [courseToEdit, reduxData, dispatch, isCourseFinished]);

  const matriculados = useMemo(() => {
    if (!Array.isArray(enrolled)) {
      return [];
    }
    return enrolled;
  }, [enrolled]);

  useEffect(() => {
    const initialGrades = {};
    matriculados.forEach((emp) => {
      const id = emp.codemp || emp.id;
      const e = ((typeof emp.nota_escrita !== 'undefined') && (emp.nota_escrita !== null)) ?
        emp.nota_escrita :
        '';
      const p = ((typeof emp.nota_practica !== 'undefined') && (emp.nota_practica !== null)) ?
        emp.nota_practica :
        '';
      initialGrades[id] = {'escrita': e, 'practica': p};
    });
    setGrades(initialGrades);
  }, [matriculados]);

  const getEmpData = (id) => {
    const emp = certEmployees.find((e) => String(e.id) === String(id)) ||
      allEmployees.find((e) => String(e.id) === String(id)) ||
      rucEmployees.find((e) => String(e.id) === String(id));
    return emp || {};
  };

  const getDealerName = (ruc) => {
    if ((!ruc) || (ruc === 'N/A')) {
      return 'N/A';
    }
    const found = dealers.find((d) => String(d.ruc) === String(ruc));
    return found ? found.description : ruc;
  };

  const handleGradeChange = (id, field, value) => {
    if ((value === '') || ((Number(value) >= 0) && (Number(value) <= 100))) {
      setGrades((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          [field]: value,
        },
      }));
    }
  };

  const calculateFinalGrade = (escrito, practica) => {
    const e = Number(escrito) || 0;
    const p = Number(practica) || 0;
    return (e + p) / 2;
  };

  const enrichedData = useMemo(() => {
    return matriculados.map((m) => {
      const id = m.codemp || m.id;
      const empData = getEmpData(id);

      const names = m.names || empData.names || m.nombres || empData.nombres || '';
      const lastNames = m.last_names || empData.last_names || m.apellidos || empData.apellidos || '';
      const fullName = `${names} ${lastNames}`.trim() || 'Desconocido';
      const doc = m.document || empData.document || m.cedula || empData.cedula || 'N/A';

      let rucDealer = m.ruc_concesionario || m.ruc || empData.ruc_concesionario || empData.ruc;

      let rawDealerDesc = m.dealer_description ||
        empData.dealer_description ||
        m.concesionario ||
        empData.dealer;

      if ((!rawDealerDesc) || (rawDealerDesc === 'N/A')) {
        rawDealerDesc = rucDealer || 'N/A';
      }

      if ((!rucDealer) && (rawDealerDesc !== 'N/A')) {
        const foundByDesc = dealers.find((d) => d.description === rawDealerDesc);
        if (foundByDesc) {
          rucDealer = foundByDesc.ruc;
        }
      }

      const dealerName = getDealerName(rucDealer || rawDealerDesc);

      const agency = m.agency_description || empData.agency_description ||
        m.agencia || empData.agency || m.agency || 'N/A';

      const currentValE = (typeof grades[id]?.escrita !== 'undefined') ? grades[id].escrita : '';
      const currentValP = (typeof grades[id]?.practica !== 'undefined') ? grades[id].practica : '';

      const hasEscrita = (currentValE !== '') && (typeof currentValE !== 'undefined');
      const hasPractica = (currentValP !== '') && (typeof currentValP !== 'undefined');
      const hasGrade = hasEscrita || hasPractica;

      const numE = hasEscrita ? Number(currentValE) : null;
      const numP = hasPractica ? Number(currentValP) : null;

      const finalGrade = (hasEscrita && hasPractica) ?
        calculateFinalGrade(currentValE, currentValP).toFixed(2) :
        '';

      const escritaApproved = (numE !== null) ? (numE >= writenTestValue) : null;
      const practicaApproved = (numP !== null) ? (numP >= practicesValue) : null;

      const bothEvaluated = (escritaApproved !== null) && (practicaApproved !== null);

      let rowBg = '';
      let rowColor = '#333';
      let approvalStatus = '';
      let statusColor = '';

      if (bothEvaluated) {
        const bothPassed = escritaApproved && practicaApproved;

        if (bothPassed) {
          approvalStatus = 'Aprobado';
          statusColor = '#21ba45';
          rowBg = '#e6ffed';
          rowColor = '#1a7a32';
        } else {
          approvalStatus = 'Reprobado';
          statusColor = '#db2828';
          rowBg = '#ffe6e6';
          rowColor = '#a31515';
        }
      } else if (hasGrade) {
        if ((escritaApproved === false) || (practicaApproved === false)) {
          approvalStatus = 'Reprobado';
          statusColor = '#db2828';
          rowBg = '#ffe6e6';
          rowColor = '#a31515';
        }
      }

      return {
        'id': String(id),
        'doc': String(doc),
        fullName,
        'dealer': dealerName,
        'rucDealer': String(rucDealer || 'N/A'),
        agency,
        'escrita': String(currentValE),
        'practica': String(currentValP),
        'grade': String(finalGrade),
        hasGrade,
        'numGrade': Number(finalGrade) || 0,
        rowBg,
        rowColor,
        approvalStatus,
        statusColor,
        'numE': numE,
        'numP': numP,
      };
    });
  }, [
    matriculados, certEmployees, allEmployees, rucEmployees,
    dealers, grades, writenTestValue, practicesValue,
  ]);

  useEffect(() => {
    if ((!userDealerSet) && (enrichedData.length > 0) && currentUser && (dealers.length > 0)) {
      const userRuc = currentUser.ruc || currentUser.dealerId || currentUser.ruc_concesionario;
      if (userRuc) {
        const expectedDealerName = getDealerName(userRuc);
        const match = enrichedData.find((item) => {
          return (item.rucDealer === String(userRuc)) || (item.dealer === expectedDealerName);
        });
        if (match) {
          setFilters((f) => ({...f, 'dealer': match.dealer}));
        } else if ((expectedDealerName !== 'N/A') && (expectedDealerName !== String(userRuc))) {
          setFilters((f) => ({...f, 'dealer': expectedDealerName}));
        }
      }
      setUserDealerSet(true);
    }
  }, [enrichedData, currentUser, dealers, userDealerSet]);

  const filteredAndSortedData = useMemo(() => {
    const data = enrichedData.filter((item) => {
      return Object.keys(filters).every((key) => {
        if ((filters[key] === 'ALL') || (!filters[key])) {
          return true;
        }
        return item[key] === filters[key];
      });
    });

    if (sortConfig.key && sortConfig.direction) {
      data.sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        if ((sortConfig.key === 'id') || (sortConfig.key === 'grade')) {
          valA = Number(valA) || 0;
          valB = Number(valB) || 0;
        } else {
          valA = String(valA).toLowerCase();
          valB = String(valB).toLowerCase();
        }

        if (valA < valB) {
          return (sortConfig.direction === 'asc') ? -1 : 1;
        }
        if (valA > valB) {
          return (sortConfig.direction === 'asc') ? 1 : -1;
        }
        return 0;
      });
    }

    return data;
  }, [enrichedData, filters, sortConfig]);

  const getOptions = (key) => {
    let optionsList = [];

    if ((key === 'dealer') && (dealers.length > 0)) {
      optionsList = [...new Set(enrichedData.map((item) => item.dealer))].filter(Boolean);
    } else {
      optionsList = [...new Set(enrichedData.map((item) => item[key]))].filter(Boolean);
    }

    return [
      {'key': 'ALL', 'text': 'Todos', 'value': 'ALL'},
      ...optionsList.sort().map((v) => ({'key': v, 'text': v, 'value': v})),
    ];
  };

  const requestSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        if (prev.direction === 'asc') {
          return {'key': key, 'direction': 'desc'};
        }
        if (prev.direction === 'desc') {
          return {'key': null, 'direction': null};
        }
      }
      return {'key': key, 'direction': 'asc'};
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({...prev, [key]: value || 'ALL'}));
  };

  const handleSave = async() => {
    if (!courseToEdit?.id) {
      return;
    }

    setIsSaving(true);
    const userMod = currentUser?.user || currentUser?.username || 'ADMIN';
    const today = moment().format('YYYY-MM-DD');
    const courseName = String(courseToEdit.course || courseToEdit.description || 'Certificado').toUpperCase();

    const updatePromises = matriculados.map((emp) => {
      const id = emp.codemp || emp.id;
      const valE = grades[id]?.escrita;
      const valP = grades[id]?.practica;

      const numE = ((valE === '') || (typeof valE === 'undefined')) ? null : Number(valE);
      const numP = ((valP === '') || (typeof valP === 'undefined')) ? null : Number(valP);
      const finalG = ((numE !== null) && (numP !== null)) ? Number(calculateFinalGrade(numE, numP).toFixed(2)) : null;

      const bothPassed = (numE !== null) && (numP !== null) &&
        (numE >= writenTestValue) && (numP >= practicesValue);

      const promises = [];

      const payload = {
        'id_agenda': courseToEdit.id,
        'codemp': id,
        'nuevo_estado': emp.status || emp.estado || 'E',
        'usuario_modificacion': userMod,
        'nota_escrita': numE,
        'nota_practica': numP,
        'nota': finalG,
        'calificacion': finalG,
      };

      if (typeof updateWtsMatricula === 'function') {
        promises.push(dispatch(updateWtsMatricula(payload)));
      }

      if (bothPassed) {
        const empData = getEmpData(id);
        const empCerts = Array.isArray(empData.certificates) ? empData.certificates : [];

        const alreadyHasCert = empCerts.some((c) => {
          if ((typeof c === 'object') && (c !== null)) {
            return (String(c.certificate).toUpperCase() === courseName) &&
                   (String(c.idcourse) === String(courseToEdit.id));
          }
          return String(c).toUpperCase() === courseName;
        });

        if ((!alreadyHasCert) && (typeof createWtsCertificacion === 'function')) {
          const certPayload = {
            'codemp': id,
            'idcourse': courseToEdit.id,
            'certificate': courseName,
            'status': 'ACTIVO',
            'certificateDate': today,
          };
          promises.push(dispatch(createWtsCertificacion(certPayload)));
        }
      }

      return Promise.all(promises);
    });

    try {
      await Promise.all(updatePromises);

      if (courseStatus === 'E') {
        const areaId = reduxData.areaSelected?.id || reduxData.areaSelected?.value || 1;
        const agendaPayload = {
          ...courseToEdit,
          'estado': 'C',
          'status': 'C',
          'usuario_modificacion': userMod,
        };

        if (typeof updateWtsAgenda === 'function') {
          await dispatch(updateWtsAgenda(areaId, agendaPayload));
        }
      }

      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  const headerStyle = {
    'display': 'flex',
    'justifyContent': 'space-between',
    'alignItems': 'center',
    'cursor': 'pointer',
    'userSelect': 'none',
  };

  return (
    <>
      <Segment
        padded="very"
        loading={loading}
        style={{
          'minHeight': '400px', 'display': 'flex', 'flexDirection': 'column',
          'border': 'none', 'boxShadow': 'none', 'padding': '0',
        }}
      >
        <div
          style={{
            'backgroundColor': '#ffffff',
            'padding': '15px 20px',
            'borderRadius': '8px',
            'border': '1px solid #e0e0e0',
            'marginBottom': '20px',
            'display': 'flex',
            'justifyContent': 'space-between',
            'alignItems': 'center',
            'boxShadow': '0 2px 4px rgba(0,0,0,0.02)',
          }}
        >
          <div>
            <div style={{'margin': '0 0 5px 0', 'color': '#333', 'fontWeight': 'bold', 'fontSize': '1em'}}>
              <Icon name="star" style={{'color': '#fbbd08'}} /> Calificación de Matriculados
            </div>
            <div style={{'margin': '0', 'fontWeight': 'normal', 'color': '#555', 'fontSize': '0.9em'}}>
              Estudiantes (Filtrados): <strong>{isCourseFinished ? filteredAndSortedData.length : 0}</strong>
            </div>
          </div>
        </div>

        <div style={{'flex': 1, 'overflowY': 'auto', 'overflowX': 'auto', 'width': '100%'}}>
          {!isCourseFinished ? (
            <Message
              warning
              icon="warning sign"
              content="El curso debe estar en estado En Curso (E) para calificar."
            />
          ) : (matriculados.length > 0) ? (
            <div style={{'minWidth': '1200px'}}>
              <Table celled compact="very" size="small" textAlign="center" unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell style={{'minWidth': '90px'}}>
                      <div style={headerStyle} onClick={() => requestSort('id')}>
                        <span>Cód</span>
                        <SortIcon direction={(sortConfig.key === 'id') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('id')}
                        value={filters.id}
                        onChange={(e, {value}) => handleFilterChange('id', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '120px'}}>
                      <div style={headerStyle} onClick={() => requestSort('doc')}>
                        <span>Cédula</span>
                        <SortIcon direction={(sortConfig.key === 'doc') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('doc')}
                        value={filters.doc}
                        onChange={(e, {value}) => handleFilterChange('doc', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '220px'}}>
                      <div style={headerStyle} onClick={() => requestSort('fullName')}>
                        <span>Estudiante</span>
                        <SortIcon direction={(sortConfig.key === 'fullName') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('fullName')}
                        value={filters.fullName}
                        onChange={(e, {value}) => handleFilterChange('fullName', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '200px'}}>
                      <div style={headerStyle} onClick={() => requestSort('dealer')}>
                        <span>Concesionario</span>
                        <SortIcon direction={(sortConfig.key === 'dealer') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('dealer')}
                        value={filters.dealer}
                        onChange={(e, {value}) => handleFilterChange('dealer', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '160px'}}>
                      <div style={headerStyle} onClick={() => requestSort('agency')}>
                        <span>Agencia</span>
                        <SortIcon direction={(sortConfig.key === 'agency') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('agency')}
                        value={filters.agency}
                        onChange={(e, {value}) => handleFilterChange('agency', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '110px'}}>
                      <span>Escrita (Min: {writenTestValue})</span>
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '110px'}}>
                      <span>Práctica (Min: {practicesValue})</span>
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '140px'}}>
                      <div style={headerStyle} onClick={() => requestSort('grade')}>
                        <span>Promedio</span>
                        <SortIcon direction={(sortConfig.key === 'grade') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('grade')}
                        value={filters.grade}
                        onChange={(e, {value}) => handleFilterChange('grade', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{'minWidth': '130px'}}>
                      <div style={headerStyle} onClick={() => requestSort('approvalStatus')}>
                        <span>Estado</span>
                        <SortIcon direction={(sortConfig.key === 'approvalStatus') ? sortConfig.direction : null} />
                      </div>
                      <Dropdown
                        placeholder="Filtrar"
                        fluid
                        search
                        selection
                        options={getOptions('approvalStatus')}
                        value={filters.approvalStatus}
                        onChange={(e, {value}) => handleFilterChange('approvalStatus', value)}
                        style={{'marginTop': '10px'}}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {filteredAndSortedData.map((item) => (
                    <Table.Row key={item.id}>
                      <Table.Cell>{item.id}</Table.Cell>
                      <Table.Cell>{item.doc}</Table.Cell>
                      <Table.Cell textAlign="left">{item.fullName}</Table.Cell>
                      <Table.Cell>{item.dealer}</Table.Cell>
                      <Table.Cell>{item.agency}</Table.Cell>
                      <Table.Cell style={{'backgroundColor': item.rowBg}}>
                        <Input
                          fluid
                          type="number"
                          min="0"
                          max="100"
                          placeholder="Ej. 85"
                          value={item.escrita}
                          onChange={(e, {value}) => handleGradeChange(item.id, 'escrita', value)}
                          style={{'color': item.rowColor}}
                        />
                      </Table.Cell>
                      <Table.Cell style={{'backgroundColor': item.rowBg}}>
                        <Input
                          fluid
                          type="number"
                          min="0"
                          max="100"
                          placeholder="Ej. 85"
                          value={item.practica}
                          onChange={(e, {value}) => handleGradeChange(item.id, 'practica', value)}
                          style={{'color': item.rowColor}}
                        />
                      </Table.Cell>
                      <Table.Cell style={{
                        'backgroundColor': item.rowBg,
                        'color': item.rowColor,
                        'fontWeight': 'bold',
                        'fontSize': '1.1em',
                      }}>
                        {(item.grade !== '') ? item.grade : '-'}
                      </Table.Cell>
                      <Table.Cell style={{'color': item.statusColor, 'fontWeight': 'bold'}}>
                        {item.approvalStatus}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <Message
              warning
              icon="info circle"
              content="No hay estudiantes en estado matriculado para calificar."
            />
          )}
        </div>
      </Segment>

      <div style={{
        'marginTop': '20px', 'textAlign': 'right',
        'borderTop': '1px solid #e0e0e0', 'paddingTop': '15px',
      }}>
        <Button color="grey" onClick={onClose}>
          Cerrar
        </Button>
        {isCourseFinished && (matriculados.length > 0) && (
          <Button
            color="green"
            icon="save"
            content="Guardar Calificaciones"
            labelPosition="left"
            onClick={() => setConfirmOpen(true)}
            loading={isSaving}
            disabled={isSaving}
          />
        )}
      </div>

      <Modal size="mini" open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <Modal.Header>Confirmar Guardado</Modal.Header>
        <Modal.Content>
          <p>
            {(courseStatus === 'E') ?
              '¿Está seguro que desea guardar las calificaciones? El curso se cerrará.' :
              '¿Está seguro que desea actualizar las calificaciones?'}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => setConfirmOpen(false)}
            style={{'backgroundColor': '#db2828', 'color': '#ffffff'}}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setConfirmOpen(false);
              handleSave();
            }}
            style={{'backgroundColor': '#21ba45', 'color': '#ffffff'}}
          >
            Sí, continuar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default WtsCalificacionMatriculados;
